module.exports = __webpack_public_path__ + "static/media/400277_02.838cec68.png";